export enum CustomActionType {
  Focus = 'focus',
}
